function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  id: "school"
}, /*#__PURE__*/React.createElement("path", {
  d: "M1.907,13C1.937,13,1.971,13,2,13l0,0c0-1.103,0.897-2,2-2h3.646c0.597,0,1.182-0.242,1.604-0.664l6.043-6.043L16,3.586 l0.707,0.707l6.043,6.043C23.172,10.758,23.757,11,24.354,11H28c1.103,0,2,0.897,2,2l0,0c0.029,0,0.063,0,0.093,0 c0.409,0,0.788-0.199,1.004-0.547c0.215-0.348,0.235-0.776,0.054-1.143l-1.628-3.265C29.202,7.403,28.546,7,27.828,7h-3.975 c-0.547,0-1.07-0.217-1.457-0.604L16,0L9.604,6.396C9.217,6.783,8.693,7,8.146,7H4.173C3.454,7,2.798,7.406,2.478,8.05 l-1.629,3.273c-0.182,0.366-0.161,0.786,0.054,1.134C1.118,12.805,1.498,13,1.907,13z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M31,27h-1h-1V13c0-0.553-0.447-1-1-1h-3.646c-0.866,0-1.698-0.345-2.311-0.957L16,5l-6.043,6.043 C9.345,11.655,8.513,12,7.646,12H4c-0.553,0-1,0.447-1,1v14H2H1c-0.553,0-1,0.447-1,1v1c0,0.553,0.447,1,1,1h12v-3v-4 c0-0.553,0.447-1,1-1h4c0.553,0,1,0.447,1,1v4v3h12c0.553,0,1-0.447,1-1v-1C32,27.447,31.553,27,31,27z M5,16c0-0.553,0.447-1,1-1 h2c0.553,0,1,0.447,1,1v2c0,0.553-0.447,1-1,1H6c-0.553,0-1-0.447-1-1V16z M5,22c0-0.553,0.447-1,1-1h2c0.553,0,1,0.447,1,1v2 c0,0.553-0.447,1-1,1H6c-0.553,0-1-0.447-1-1V22z M15,18c0,0.553-0.447,1-1,1h-2c-0.553,0-1-0.447-1-1v-2c0-0.553,0.447-1,1-1h2 c0.553,0,1,0.447,1,1V18z M23,16c0-0.553,0.447-1,1-1h2c0.553,0,1,0.447,1,1v2c0,0.553-0.447,1-1,1h-2c-0.553,0-1-0.447-1-1V16z  M23,22c0-0.553,0.447-1,1-1h2c0.553,0,1,0.447,1,1v2c0,0.553-0.447,1-1,1h-2c-0.553,0-1-0.447-1-1V22z M18,19 c-0.553,0-1-0.447-1-1v-2c0-0.553,0.447-1,1-1h2c0.553,0,1,0.447,1,1v2c0,0.553-0.447,1-1,1H18z"
}));

var _ref3 = /*#__PURE__*/React.createElement("g", {
  id: "Layer_1"
});

var SvgSchool = function SvgSchool(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    x: "0px",
    y: "0px",
    width: "100%",
    height: "100%",
    viewBox: "0 0 32 30",
    style: {
      enableBackground: "new 0 0 32 30"
    },
    xmlSpace: "preserve",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgSchool, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/school.12f1608d.svg";
export { ForwardRef as ReactComponent };